import { render, staticRenderFns } from "./CharSlogan.vue?vue&type=template&id=4bb7ad5f&"
import script from "./CharSlogan.vue?vue&type=script&lang=js&"
export * from "./CharSlogan.vue?vue&type=script&lang=js&"
import style0 from "./CharSlogan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports